import { useContext } from 'react';

import { AuthDataContext } from '../../AuthDataContext';
import { AuthData } from '../../types';

export const useAuthData = (): AuthData => {
  const data = useContext(AuthDataContext);

  if (data === undefined) {
    throw new Error('useAuthData must be used within an AuthProvider');
  }

  return data;
};
